import { render } from "./IconPdf.vue?vue&type=template&id=aa298478"
import script from "./IconPdf.vue?vue&type=script&lang=js"
export * from "./IconPdf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconPdf.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa298478"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa298478', __exports__)) {
    api.reload('aa298478', __exports__)
  }
  
  module.hot.accept("./IconPdf.vue?vue&type=template&id=aa298478", () => {
    api.rerender('aa298478', render)
  })

}


export default __exports__